import cn from 'classnames';
import {ChevronRight} from '@/_application/icons/chevron-right';
import {ChevronLeft} from '@/_application/icons/chevron-left';
import React, {RefObject} from 'react';
import {useIsRTL} from '@/lib/locals';

interface ChevronProps {
    classNamePrev?: string;
    classNameNext?: string;
    prevRef: RefObject<HTMLDivElement | null>;
    nextRef: RefObject<HTMLDivElement | null>;
}

export const ChevronButton = ({classNamePrev, classNameNext, prevRef, nextRef}: ChevronProps) => {
    const baseClasses = `absolute top-2/4 z-10 -mt-4 flex h-11 w-11 cursor-pointer items-center justify-center
    rounded-full border border-border-100 border-opacity-70 bg-primary-0 text-heading shadow-xl transition-all
    duration-200 hover:bg-gray-100 md:-mt-5 md:h-11 md:w-11`;

    const {isRTL} = useIsRTL();
    return (
        <>
            <div ref={prevRef} className={cn(baseClasses, 'product-gallery-prev', classNamePrev)}>
                {isRTL ? (
                    <ChevronRight className="h-6 w-6 text-primary" />
                ) : (
                    <ChevronLeft className="h-6 w-6 text-primary" />
                )}
            </div>
            <div ref={nextRef} className={cn(baseClasses, 'product-gallery-next', classNameNext)}>
                {isRTL ? (
                    <ChevronLeft className="h-6 w-6 text-primary" />
                ) : (
                    <ChevronRight className="h-6 w-6 text-primary" />
                )}
            </div>
        </>
    );
};
